import * as Yup from 'yup';

export type FlightSaleAddOnsType = {
  isSelected?: boolean;
  id: string;
  description?: string;
  price: number;
  guestId: string;
  route: string;
};

export type FlightSaleGuestType = {
  isSelected?: boolean;
  ticket: string;
  airlineId: string;
  date: Date;
  detail: string;
  preferenceId?: string;
  route: string;
  time: string;
  price: number;
  id: string;
  guestId: string;
  preferences: string[];
  checkInStatus: string | null;

  //additional
  guestName: string;
};

export type FlightSaleType = {
  isSelected?: boolean;
  id: string;
  bookingCode?: string | null;
  flightSaleGuests: FlightSaleGuestType[];
  flightSaleAddOns: FlightSaleAddOnsType[];
};

export type FlightRescheduleFormType = {
  flightSales: FlightSaleType[];
  transactionAt: Date | null;
  total: number;
};

export const FlightRescheduleSchema = Yup.object()
  .shape({
    transactionAt: Yup.date().nullable().required(),
    flightSales: Yup.array().of(
      Yup.object({
        id: Yup.string().required(),
        bookingCode: Yup.string().nullable().notRequired(),
        flightSaleGuests: Yup.array().of(
          Yup.object({
            checkInStatus: Yup.string().nullable().default(null),
            ticket: Yup.string().nullable().notRequired(),
            airlineId: Yup.string().nullable().required(),
            date: Yup.date().nullable().required(),
            detail: Yup.string().notRequired(),
            preferenceId: Yup.string().nullable(),
            route: Yup.string().notRequired(),
            time: Yup.string().nullable().required(),
            price: Yup.number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0)
              .required(),
            id: Yup.string().required(),
            guestId: Yup.string().nullable().required(),
          }),
        ),
        flightSaleAddOns: Yup.array().of(
          Yup.object({
            description: Yup.string().notRequired(),
            price: Yup.number()
              .transform((value) => (isNaN(value) ? undefined : value))
              .min(0)
              .required(),
            id: Yup.string().nullable().required(),
            guestId: Yup.string().nullable().required(),
            route: Yup.string().nullable().required(),
          }),
        ),
      }),
    ),
  })
  .required();
